import { Box } from '@mui/material';
import { Dialog, TextField } from 'components/commons';
import ja from 'utils/ja';

interface EditTagDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  value: string;
  setValue: (val: string) => void;
  errorMessage?: string;
}

const EditTagDialog = ({
  open,
  onClose,
  handleConfirm,
  value,
  setValue,
  errorMessage,
}: EditTagDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.tag.dialog_edit.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '500px' },
          padding: '10px',
          '& *': {
            fontSize: '18px !important',
          },
        }}
      >
        <TextField
          id='tagName'
          label={ja.tag.tags}
          require
          placeholder={ja.tag.content}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === ',' || e.key === ' ') {
              e.preventDefault();
            }
          }}
          error={errorMessage && { message: errorMessage }}
        />
      </Box>
    </Dialog>
  );
};
export default EditTagDialog;
